/** @format */
import { css } from 'styled-components';

import { largeTablet } from '@toucan/client/global/application';
import { theme } from '@toucan/client/global/theme';

/* eslint-disable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
export const styles = css`
    /*
     * Equal 1fr rows above and below the circle's row put its centre on the
     * same line every timeline stop's dot sits on, which is what lets the
     * parent draw one straight axis through them all.
     */
    display: grid;
    grid-template-rows: 1fr auto 1fr;
    justify-items: center;

    .timeline-marker-text {
        grid-row: 1;
        align-self: end;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: var(--layout-spacing-2);
        padding-bottom: var(--layout-spacing-12);
        text-align: center;
        max-width: 20rem;
    }

    .timeline-marker-name {
        ${theme.typography.body_normal_highlight}
        color: var(--colors-text-secondary);
        overflow-wrap: anywhere;
    }

    .timeline-marker-label {
        ${theme.typography.caption_highlight}
        color: var(--colors-brand-secondary);
        text-transform: uppercase;
        letter-spacing: 0.05em;
    }

    .timeline-marker-circle {
        grid-row: 2;
        /*
         * Positioned so the circle and its ring always paint above the axis.
         * The axis is drawn to stop short of the circle, so this is only a
         * guard against a stray pixel of line showing through the ring.
         */
        position: relative;
        /*
         * --journey-timeline__marker-size is set by whatever holds this marker,
         * so its circle matches the axis it sits on; the fallback keeps this
         * component usable on its own in Storybook.
         */
        width: var(--journey-timeline__marker-size, 6.4rem);
        height: var(--journey-timeline__marker-size, 6.4rem);
        border-radius: var(--effects-radius-full);
        background-color: var(--colors-brand-primary);
        display: grid;
        place-items: center;
        /* A white gap then the pink ring, both drawn outside the circle so they cost no layout. */
        box-shadow:
            0 0 0 0.4rem var(--colors-surface-primary),
            0 0 0 0.6rem var(--colors-brand-secondary);
    }

    .timeline-marker-circle svg {
        width: 2.4rem;
        height: 2.4rem;
    }

    /* The shared arrow asset hard-codes its fill, so it has to be overridden here. */
    .timeline-marker-circle svg path {
        fill: var(--colors-text-inverse);
    }

    ${largeTablet(css`
        grid-template-rows: auto;
        grid-template-columns:
            var(--journey-timeline__axis-size, 5.6rem)
            minmax(0, 1fr);
        align-items: center;
        justify-items: start;

        .timeline-marker-text {
            grid-row: 1;
            grid-column: 2;
            align-self: center;
            align-items: flex-start;
            padding-bottom: 0;
            padding-left: var(--layout-spacing-12);
            text-align: left;
        }

        /*
         * The parent runs its vertical axis line down the centre of the
         * axis-width column, so centring the circle in that same column
         * puts the circle on the line.
         */
        .timeline-marker-circle {
            grid-row: 1;
            grid-column: 1;
            justify-self: center;
            width: var(--journey-timeline__marker-size, 5.6rem);
            height: var(--journey-timeline__marker-size, 5.6rem);
        }
    `)}
`;
/* eslint-enable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
